import { render, staticRenderFns } from "./com_ok_cancel.vue?vue&type=template&id=a85036c4&scoped=true&"
import script from "./com_ok_cancel.vue?vue&type=script&lang=js&"
export * from "./com_ok_cancel.vue?vue&type=script&lang=js&"
import style0 from "./com_ok_cancel.vue?vue&type=style&index=0&id=a85036c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85036c4",
  null
  
)

export default component.exports